import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { getArticlesByCategory } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const { category, articles } = getArticlesByCategory(slug || '');

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="font-heading text-3xl font-bold text-foreground-950 mb-4">分类不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 underline cursor-pointer">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} - 91爆料网`,
          description: category.description,
          url: `http://gm3pta.cn/category/${slug}`,
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://gm3pta.cn/' },
            { '@type': 'ListItem', position: 2, name: category.name, item: `http://gm3pta.cn/category/${slug}` },
          ],
        }}
      />

      <Navbar />

      <main className="pt-16">
        <section className="bg-foreground-900">
          <div className="px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-20">
            <span className="inline-block px-3 py-1 bg-primary-500/20 text-primary-300 text-xs rounded-full mb-4">
              {category.name}
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4">
              {category.name}
            </h1>
            <p className="text-foreground-300 text-sm md:text-base max-w-2xl leading-relaxed">
              {category.description}
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <Breadcrumb categorySlug={slug} />

            <div className="flex items-center gap-1.5 overflow-x-auto pb-2 mb-6 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                  <span className={`text-xs ml-1 ${cat.slug === slug ? 'text-background-50/70' : 'text-foreground-400'}`}>
                    {cat.count}
                  </span>
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-4">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="h-[200px] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-foreground-400 text-xs">
                      <span>{article.date}</span>
                      <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {articles.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-400">该分类下暂无文章</p>
              </div>
            )}

            <div className="flex flex-col sm:flex-row items-center justify-between mt-10 pt-6 border-t border-background-200/70">
              <Link to="/" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer">
                <i className="ri-arrow-left-line mr-1"></i>返回首页
              </Link>
              <div className="flex items-center gap-2 mt-4 sm:mt-0">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer">1</span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 text-sm hover:bg-background-100 cursor-pointer">2</span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 text-sm hover:bg-background-100 cursor-pointer">3</span>
                <span className="text-foreground-400 text-sm mx-1">...</span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 text-sm hover:bg-background-100 cursor-pointer">8</span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 text-sm hover:bg-background-100 cursor-pointer">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}